// CLASSES
import AppConfig from "@classes/AppConfig";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	const {fields, validFields} = state;

	for (const name in validFields) {
		if (validFields[name] === false) {
			return false;
		}
	}

	/**
	 * Source of funds needs to be checked
	 */
	if (!optionsListValueSelected(fields.futur_kyc_privat_source)) {
		return false;
	}

	/**
	 * We need to know if this is a foreign entity or not
	 */
	if (!optionsListValueSelected(fields.futur_kyc_privat_is_foreign)) {
		return false;
	}

	// PEP needs to be checked
	if (!optionsListValueSelected(fields.radio_customer_pep)) {
		return false;
	}

	// Fatca question needs to be checked
	if (!optionsListValueSelected(fields.radio_customer_fatca)) {
		return false;
	}

	/**
	 * If US person we need to enter TIN
	 */
	if (fields.radio_customer_fatca.options[1].checked && fields.futur_kyc_privat_us_tin.length === 0) {
		return false;
	}

	/**
	 * If other source of funds selected it needs to be entered manually
	 */
	if (fields.futur_kyc_privat_source.options[5].checked && fields.futur_kyc_privat_source_other.length === 0) {
		return false;
	}

	return true;
}

function optionsListValueSelected(optionsList) {
	const options = optionsList.options;
	for (let i = 0; i < options.length; i++) {
		if (options[i].checked) {
			return true;
		}
	}
	return false;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/KycPrivatperson/KycPrivatperson.fulfillment.js